module.exports = __webpack_public_path__ + "img/yiyao_foci_suoluetu.666f0b47.png";